import api from '@/shared/api';
import type { ApiResponse } from '@/shared/lib';
import type { RecordControl } from '../model/record-modal.types';

export async function getRecordControl(id: number): Promise<RecordControl> {
  const response = await api.get<ApiResponse<RecordControl>>(`/matrices/${id}/control`);

  return response.data.data!;
}
